import React, { FC, useState } from 'react'
import { AccordionProps } from './Accordion.types'
import './Accordion.module.scss'
import { addBaseDomain, sanitizeHTML } from '../../../../../utils/common-utils'
import { BrandIcon } from '../../BrandIconCompound'

export const Accordion: FC<AccordionProps> = props => {
  const {
    sections,
    intro,
    disclaimer,
    componentParams,
    displayName,
    layoutConfigs,
    sizeConstrained,
    shouldGrow,
  } = props
  const verticalSpace = layoutConfigs?.verticalSpacing || ''
  const colSize = layoutConfigs?.columnSize ? `u-size${layoutConfigs.columnSize}` : ''
  const sizeConstrain = sizeConstrained ?? ''

  const [openIndex, setOpenIndex] = useState<number>(0)
  const isDlg = window.location.pathname.includes('lending-solutions-guide')

  const handleAccordionClick = (
    e: React.MouseEvent<HTMLDetailsElement, MouseEvent>,
    index: number
  ) => {
    if (isDlg) {
      e.preventDefault()
      setOpenIndex(index)
    }
  }
  return (
    <div
      id={`${componentParams?.anchorIdentifier}`}
      data-testid={`${componentParams?.anchorIdentifier}`}
      className={`Accordion-component microsite-accordion ${sizeConstrain} ${verticalSpace} ${colSize}${
        shouldGrow ? ' u-flexGrow' : ''
      }`}
    >
      {intro && (
        <div className='Accordion-intro Content u-marginBottom24'>
          <div dangerouslySetInnerHTML={{ __html: sanitizeHTML(intro ?? '') }}></div>
        </div>
      )}
      {sections && (
        <div className='Accordion'>
          {sections?.heading && (
            <div className='Content section-title'>
              <h2 className='u-marginBottom24'>{sections?.heading}</h2>
            </div>
          )}
          {sections?.innerCompound?.map((item, index) => {
            const updatedContent = addBaseDomain(item.content as string)
            return (
              <details
                key={item.heading}
                className='Accordion-item'
                data-analytics-component-name='Accordion'
                data-analytics-content-document-name={displayName}
                data-analytics-component-template={componentParams?.template}
                open={isDlg && index === openIndex}
                {...(isDlg && { onClick: e => handleAccordionClick(e, index) })}
              >
                <summary
                  className='Accordion-toggle'
                  data-analytics={item.dataAnalytics || 'content-accordion'}
                >
                  {item?.icon?.iconsDropdown && (
                    <BrandIcon
                      {...item.icon}
                      className={`${item.icon.className} Accordion-icon u-marginRight8`}
                    />
                  )}
                  <span
                    dangerouslySetInnerHTML={{ __html: sanitizeHTML(item?.heading ?? '') }}
                  ></span>
                </summary>
                <div
                  className='Accordion-content Content'
                  dangerouslySetInnerHTML={{
                    __html: sanitizeHTML(updatedContent ?? ''),
                  }}
                ></div>
              </details>
            )
          })}
        </div>
      )}
      {disclaimer && (
        <div
          className='Accordion-disclaimer Content u-marginTop24'
          dangerouslySetInnerHTML={{ __html: sanitizeHTML(disclaimer || '') }}
        ></div>
      )}
    </div>
  )
}
